import React, { Component } from "react";
import GoogleAd from "../../../components/google/GoogleAd";
import ComponentHasTranslations from "../../../utils/component_has_translations";
import Tap from "./Tap";
import Shares from "./Shares";
import ShareActions from "./ShareActions";
import { ConsentBannerWithQueryClient } from "../../../components/consent-mode/ConsentBanner";

class HeartRateApp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasInteracted: false,
      screenW: 0,
      screenH: 0,
    };

    this.setBreakpoints();
  }

  updateDimensions = () => {
    this.setState({
      screenW: window.innerWidth,
      screenH: window.innerHeight,
      breakpoint: this.getBreakpoint(window.innerWidth),
    });
  };

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  setBreakpoints() {
    let b = new Map(); //guarantees order

    b.set("xs", 0);
    b.set("sm", 576);
    b.set("md", 768);
    b.set("lg", 992);
    b.set("xl", 1200);

    this.breakpoints = b;
  }

  getBreakpoint = (currentWidth) => {
    for (let [breakpoint, breakpointWidth] of this.breakpoints) {
      if (currentWidth < breakpointWidth) return breakpoint;
    }
  };

  render = () => {
    return (
      <div id="heartrate-app">
        <Tap
          breakpoint={this.state.breakpoint}
          setHasInteracted={(bool) => this.setState({ hasInteracted: bool })}
          hasInteracted={this.state.hasInteracted}
          indicator_type={this.props.indicator_type}
          tr={this.props.tr}
        />
        <div id="main-ad" className="mt-5 mb-5">
          <GoogleAd />
        </div>
        <ShareActions tr={this.props.tr} />
        <Shares
          shares={this.props.shares}
          hasInteracted={this.state.hasInteracted}
          tr={this.props.tr}
        />
        <ConsentBannerWithQueryClient />
      </div>
    );
  };
}

Object.assign(HeartRateApp.prototype, ComponentHasTranslations);
export default HeartRateApp;
